import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import colors from "@constants/colors"
import animation, { cubicBezier } from "@constants/animation"
import { smallcapsBold13Styles, body14Styles } from "@constants/typography"
import AnimatedDash, {
  getAnimationStyles,
} from "@components/buttons/common/AnimatedDash"
import ProductSeriesBlock from "@components/ProductSeriesBlock"
import { getShopURL } from "@utils/urls"

const Container = styled.div`
  width: 100%;
`

const HeaderRow = styled.div`
  display: flex;
  margin-bottom: 14px;
  padding: 0 24px;
  align-items: center;
  justify-content: space-between;
`

const Header = styled.div`
  ${smallcapsBold13Styles}
  padding-top: 3px;
`

const DashWrapper = styled.div`
  margin-left: 14px;
`

const BrowseAllText = styled.span`
  ${body14Styles};
  color: ${colors.mediumGray};
  transition: color ${animation.medium} ${cubicBezier};
`

const BrowseAllButton = styled.span`
  ${getAnimationStyles(colors.black)}
  display: flex;
  height: 32px;
  align-items: center;
  background: none;
  border: none;
  outline: none;

  &:active {
    outline: none;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    cursor: pointer;

    ${BrowseAllText} {
      color: ${colors.black};
      transition: color ${animation.quick} ${cubicBezier};
    }
  }
`

const List = styled.div`
  display: flex;
`

const BlockWrapper = styled.div`
  width: 25%;
`

interface ProductSeriesProps {
  productSeriesHeader: string
  productSeries: Array<{
    link: string
    name: string
    color?: string
    icon?: string
    image: string
    onClick?: () => void
  }>
}

const ProductSeries: React.FC<ProductSeriesProps> = ({
  productSeriesHeader,
  productSeries,
}) => {
  return (
    <Container>
      <HeaderRow>
        <Header>{productSeriesHeader}</Header>
        <Link to={getShopURL()}>
          <BrowseAllButton>
            <BrowseAllText>Browse All Styles</BrowseAllText>
            <DashWrapper>
              <AnimatedDash color={colors.mediumGray} />
            </DashWrapper>
          </BrowseAllButton>
        </Link>
      </HeaderRow>
      <List>
        {productSeries.map((productSeries) => (
          <BlockWrapper key={productSeries.link}>
            <ProductSeriesBlock {...productSeries} />
          </BlockWrapper>
        ))}
      </List>
    </Container>
  )
}

export default ProductSeries
